var map = {
	"./affiliate-commission-banner-cn.webp": 1927,
	"./affiliate-commission-banner.webp": 1928,
	"./affiliate-commission-mobile-banner-cn.webp": 1929,
	"./affiliate-commission-mobile-banner.webp": 1930,
	"./comission-table.jpg": 1931,
	"./org-chart.webp": 1932,
	"./org-mobile-chart.webp": 1933,
	"./share.svg": 1934
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1926;